import { MainService } from '@/services/MainService'

export const openLefebvrePdfViewer = async (idFile: number) => {
  const url = `/pdfviewer/${idFile}/get`
  const jsonData = { env: process.env.VUE_APP_LEXBOX_ENV ? process.env.VUE_APP_LEXBOX_ENV : '' }
  const { data } = await new MainService().postData(url, jsonData)
  window.open(data.pdfUrl, '_blank')
}
